<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="productAccessoryHeaders"
        :items="admin.productAccessoryList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.productAccessoryList.length == 0"
        :hide-default-header="admin.productAccessoryList.length == 0"
      >
        <template v-slot:item.required="{ item }">
          <v-icon color="success" v-show="item.required">mdi-check</v-icon>
        </template>
        <template v-slot:item.productId="{ item }">
          {{ getProductSku(item.productId) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewProductAccessory"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        productAccessoryHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'PRODUCT', value: 'productId' },
          { text: 'MIN QTY', value: 'minQuantity' },
          { text: 'MAX QTY', value: 'maxQuantity' },
          { text: 'REQUIRED', value: 'required' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedProductAccessorySelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedProductAccessorySelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getProductAccessoryList');
        }
      }
    },
    methods: {
      /**
       * returns the description for given productId
       */
      getProductSku(productId) {
        return this.admin.productList.find((x) => x.id == productId)?.sku;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Product Attribute to currently selected product
       */
      addNewProductAccessory() {
        this.$store.commit('admin/setSelectedProductAccessory', {
          id: 'new',
          productId: 0,
          minQuantity: 0,
          maxQuantity: 0,
          required: false
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedProductAccessory', data.item);
        } else {
          this.$store.commit('admin/setSelectedProductAccessory', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedProductAccessorySelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // placeholder
      }
    }
  };
</script>
